module.exports = __webpack_public_path__ + "img/nellie-1.7a74d5e4.jpg";